import React from 'react';
import { ClipboardList, FileText, PieChart } from 'lucide-react';
import { useFeature } from '../../hooks/useFeature';

type BillingTab = 'Claims' | 'EVV Reconciliation' | 'Reports';

interface BillingBottomNavProps {
  activeTab: BillingTab;
  onTabChange: (tab: BillingTab) => void;
  sidebarCollapsed?: boolean;
}

const BillingBottomNav: React.FC<BillingBottomNavProps> = ({
  activeTab,
  onTabChange,
  sidebarCollapsed = true
}) => {
  const billingReportsEnabled = useFeature('billingReports');

  if (!sidebarCollapsed) {
    return null;
  }

  const navItems = [
    { id: 'Claims' as const, icon: FileText, label: 'Claims' },
    { id: 'EVV Reconciliation' as const, icon: ClipboardList, label: 'EVV' },
    ...(billingReportsEnabled ? [{ id: 'Reports' as const, icon: PieChart, label: 'Reports' }] : [])
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex justify-around h-16 items-center md:hidden z-50 safe-area-inset-bottom">
      {navItems.map(({ id, icon: Icon, label }) => {
        const isActive = activeTab === id;

        return (
          <button
            key={id}
            type="button"
            onClick={() => onTabChange(id)}
            className={`flex flex-col items-center justify-center w-full h-full transition-all ${
              isActive
                ? 'text-slate-700 bg-slate-100'
                : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
            }`}
            aria-label={id}
            aria-current={isActive ? 'page' : undefined}
          >
            <Icon size={24} strokeWidth={isActive ? 2.5 : 2} />
            <span className={`text-xs mt-1 ${isActive ? 'font-semibold' : 'font-medium'}`}>
              {label}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default BillingBottomNav;